import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const PENDING_KEY = 'curacheck_open_portal_after_login';
const PENDING_TTL_MS = 15 * 60 * 1000;

// Piani a pagamento: unica definizione, usata da Impostazioni e dal menu della landing
export const PAID_PLANS = ['standard', 'premium', 'fondatori', 'founder'];
export const isPaidPlan = (plan) => PAID_PLANS.includes(plan);

// onNoCustomer: chiamato quando la famiglia non ha un customer Stripe (reason "no_stripe_customer")
export const openStripePortal = async (famigliaId, { onNoCustomer } = {}) => {
  try {
    const response = await fetch(`${API_URL}/api/stripe/create-portal-session?famiglia_id=${famigliaId}`, {
      method: 'POST'
    });
    if (response.ok) {
      const data = await response.json();
      if (data.portal_url) {
        window.location.href = data.portal_url;
      } else if (data.url) {
        window.location.href = data.url;
      }
      return;
    }
    const body = await response.json().catch(() => null);
    if (body?.detail?.reason === 'no_stripe_customer' && onNoCustomer) {
      onNoCustomer();
    } else {
      toast.error('Errore nell\'apertura del portale');
    }
  } catch (err) {
    toast.error('Errore di connessione');
  }
};

export const requestPortalAfterLogin = () => {
  sessionStorage.setItem(PENDING_KEY, String(Date.now()));
};

// Legge e cancella la richiesta (valida 15 minuti)
export const consumePortalRequest = () => {
  const stamp = Number(sessionStorage.getItem(PENDING_KEY));
  sessionStorage.removeItem(PENDING_KEY);
  return Boolean(stamp) && Date.now() - stamp < PENDING_TTL_MS;
};
